import styled from "@emotion/styled"
import { Button } from "@mui/material"
import { fontSize, size } from "@styles/theme"
import { PiCaretLeftBold } from "react-icons/pi"
import { useNavigate } from "react-router-dom"

const TopBar = styled.nav`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: black;
  border-bottom: 1px solid rgba(255,255,255,0.1);

  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  height: ${size(7)};
  z-index: 2;
`

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`

const RightSection = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`

const Title = styled.div`
  font-size: ${fontSize('xl')};
  font-weight: 500;
  margin-left: ${size(3)};
`

const BackButton = styled(Button)`
  color: white;
  font-size: ${fontSize('md')};
`

const TopbarClearfix = styled.div`
  height: ${size(10)};
  flex-shrink: 0;
  width: 100%;
`

const BackTopbar = ({ title, stopNavigation=false, containerProps={}, titleProps={}, buttonProps={}, children }) => {
  const navigate = useNavigate()

  return (
    <TopBar {...containerProps}>
      <LeftSection>
        <BackButton
          onClick={() => !stopNavigation && navigate(-1)}
          {...buttonProps}>
          <PiCaretLeftBold size={size(2.5)} />
          <Title {...titleProps}>{title}</Title>
        </BackButton>
      </LeftSection>
      <RightSection>
        {children}
      </RightSection>
    </TopBar>
  )
}

export default BackTopbar
export { TopbarClearfix }
